import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import {
  FiArrowLeft, FiPlus, FiX, FiCheck, FiTarget,
  FiChevronLeft, FiChevronRight, FiEdit3
} from 'react-icons/fi';

const bowCategoriesOptions = [
  { code: '3d_hdh_trrb', label: 'TRRB (Vadászreflex)' },
  { code: '3d_hdh_bb', label: 'BB (Barebow)' },
  { code: '3d_hdh_cu', label: 'CU (Scope-os Csigás)' },
  { code: '3d_hdh_hu', label: 'HU (Vadász Csigás)' },
  { code: '3d_hdh_pbhb', label: 'PBHB (Pusztai íj (Tradi))' },
  { code: '3d_hdh_trlb', label: 'TRLB (Longbow)' },
  { code: '3d_hdh_ol', label: 'OL (Olimpiai)' },
  { code: '3d_hdh_crb', label: 'CRB (Számszeríj)' },
  { code: '3d_hdh_bg', label: 'BG (Fúvócső)' },
  { code: '3d_hdh_cb', label: 'CB (Csigás Barebow)' }
];

const defaultHitValues = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', 'X'];

const CreateWorkout = () => {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [workoutName, setWorkoutName] = useState('Délutáni edzés');
  const [selectedBowCategory, setSelectedBowCategory] = useState('3d_hdh_trrb');
  const [targetCount, setTargetCount] = useState('20');
  const [shotsPerTarget, setShotsPerTarget] = useState('3');

  const [availableValues, setAvailableValues] = useState(defaultHitValues);
  const [selectedValues, setSelectedValues] = useState(new Set(['0']));

  // Egyedi érték hozzáadása modal
  const [showAddValueModal, setShowAddValueModal] = useState(false);
  const [customValueInput, setCustomValueInput] = useState('');
  const chipScrollRef = useRef(null);

  const scrollChips = (direction) => {
    if (chipScrollRef.current) {
      chipScrollRef.current.scrollBy({
        left: direction === 'left' ? -150 : 150,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            const data = userDoc.data();
            if (data.bowCategory) setSelectedBowCategory(data.bowCategory);
          }
        } catch (e) {}
      }
    });
    return () => unsubscribe();
  }, []);

  const toggleValueSelect = (val) => {
    const nextSet = new Set(selectedValues);
    if (nextSet.has(val)) {
      nextSet.delete(val);
    } else {
      nextSet.add(val);
    }
    setSelectedValues(nextSet);
  };

  const handleAddCustomValue = () => {
    const trimmed = customValueInput.trim().toUpperCase();
    if (trimmed && !availableValues.includes(trimmed)) {
      setAvailableValues(prev => [...prev, trimmed]);
      setSelectedValues(prev => new Set(prev).add(trimmed));
    }
    setCustomValueInput('');
    setShowAddValueModal(false);
  };

  const handleStartWorkout = () => {
    if (!workoutName.trim()) {
      alert("Kérjük, add meg az edzés nevét!");
      return;
    }
    const targets = parseInt(targetCount) || 0;
    if (targets <= 0) {
      alert("Érvénytelen célok száma!");
      return;
    }
    const shots = parseInt(shotsPerTarget) || 0;
    if (shots <= 0) {
      alert("Érvénytelen célonkénti lövésszám!");
      return;
    }
    if (selectedValues.size === 0) {
      alert("Válassz ki legalább egy pontértéket!");
      return;
    }

    const workoutId = `workout_${Date.now()}_${Math.random().toString(36).substring(2, 7)}`;

    // Kezdeti üres lövéssor stability: 0 mezővel az app kompatibilitáshoz
    const initialShots = [];
    for (let t = 1; t <= targets; t++) {
      for (let s = 1; s <= shots; s++) {
        initialShots.push({
          value: '',
          sum: 0,
          target: t,
          position: s.toString(),
          stability: 0
        });
      }
    }

    const newWorkoutObj = {
      id: workoutId,
      userId: currentUser?.uid || 'guest',
      rivalId: '',
      distance: 0,
      createdAt: new Date().toISOString(),
      lastUpdated: new Date().toISOString(),
      workoutName: workoutName.trim(),
      bowCategory: selectedBowCategory,
      targetFace: '',
      targetCount: targets,
      shotsPerTarget: shots,
      possibleHitValues: Array.from(selectedValues),
      shots: initialShots,
      status: 'in_progress',
      totalScore: 0,
      averageArrowScore: 0,
      totalArrowsShot: 0,
      customNote: '',
      currentSeries: 1,
      type: 'solo',
      shared: false,
      participants: [],
      participantUids: [],
      isSystemPost: false,
      likes: [],
      congrats: [],
      wow: [],
      go: []
    };

    localStorage.setItem(`active_workout_${workoutId}`, JSON.stringify(newWorkoutObj));
    navigate(`/workout/${workoutId}`);
  };

  return (
    <div style={{ ...pageStyle, padding: isMobile ? '15px 12px 80px 12px' : '30px 20px 80px 20px' }} className="force-light-theme">
      {/* FEJLÉC */}
      <div style={headerStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <button style={backButtonStyle} onClick={() => navigate('/edzeseim')}>
            <FiArrowLeft size={22} />
          </button>
          <h2 style={{ margin: 0, color: '#b30000', fontSize: '1.3rem', fontWeight: 'bold' }}>Új Edzés Indítása</h2>
        </div>
      </div>

      <div style={{ maxWidth: '550px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {/* FORM KÁRTYA */}
        <div style={cardStyle}>
          {/* EDZÉS NEVE */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Edzés elnevezése</label>
            <input
              type="text"
              value={workoutName}
              onChange={(e) => setWorkoutName(e.target.value)}
              placeholder="Pl. Délutáni 3D edzés"
              style={inputStyle}
            />
          </div>

          {/* ÍJKATEGÓRIA */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Íjkategória</label>
            <select
              value={selectedBowCategory}
              onChange={(e) => setSelectedBowCategory(e.target.value)}
              style={selectStyle}
            >
              {bowCategoriesOptions.map(cat => (
                <option key={cat.code} value={cat.code}>{cat.label}</option>
              ))}
            </select>
          </div>

          {/* CÉLOK SZÁMA ÉS LÖVÉSEK SZÁMA */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            <div style={inputGroupStyle}>
              <label style={labelStyle}>Célok száma</label>
              <input
                type="number"
                min="1"
                max="100"
                value={targetCount}
                onChange={(e) => setTargetCount(e.target.value)}
                style={inputStyle}
              />
            </div>

            <div style={inputGroupStyle}>
              <label style={labelStyle}>Lövések száma / cél</label>
              <input
                type="number"
                min="1"
                max="12"
                value={shotsPerTarget}
                onChange={(e) => setShotsPerTarget(e.target.value)}
                style={inputStyle}
              />
            </div>
          </div>

          {/* TALÁLATI ÉRTÉKEK VÍZSZINTESEN GÖRGETHETŐ CHIP VÁLASZTÓ NYILAKKAL + PLUSZ GOMB */}
          <div style={{ marginTop: '10px' }}>
            <label style={{ ...labelStyle, marginBottom: '10px', display: 'block' }}>
              Lehetséges találati értékek
            </label>

            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              {/* BAL NYÍL */}
              <button
                type="button"
                onClick={() => scrollChips('left')}
                style={{
                  backgroundColor: '#f0f0f0',
                  border: '1px solid #ccc',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  flexShrink: 0
                }}
                title="Görgetés balra"
              >
                <FiChevronLeft size={20} color="#555" />
              </button>

              <div
                ref={chipScrollRef}
                style={{
                  display: 'flex',
                  overflowX: 'auto',
                  gap: '8px',
                  paddingBottom: '4px',
                  whiteSpace: 'nowrap',
                  scrollbarWidth: 'none',
                  WebkitOverflowScrolling: 'touch',
                  flex: 1
                }}
              >
                {availableValues.map(val => {
                  const isSelected = selectedValues.has(val);
                  return (
                    <button
                      key={val}
                      type="button"
                      onClick={() => toggleValueSelect(val)}
                      style={{
                        padding: '10px 16px',
                        borderRadius: '12px',
                        border: isSelected ? '2px solid #b30000' : '1px solid #ddd',
                        backgroundColor: isSelected ? '#b30000' : '#f0f0f0',
                        color: isSelected ? '#ffffff' : '#333333',
                        fontWeight: '900',
                        fontSize: '1rem',
                        cursor: 'pointer',
                        flexShrink: 0,
                        transition: 'all 0.15s ease'
                      }}
                    >
                      {val}
                    </button>
                  );
                })}

                {/* + GOMB EGYEDI PONTÉRTÉKHEZ */}
                <button
                  type="button"
                  onClick={() => setShowAddValueModal(true)}
                  style={{
                    padding: '10px 16px',
                    borderRadius: '12px',
                    border: '2px dashed #b30000',
                    backgroundColor: '#fff5f5',
                    color: '#b30000',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  title="Egyedi pontérték hozzáadása"
                >
                  <FiPlus size={20} />
                </button>
              </div>

              {/* JOBB NYÍL */}
              <button
                type="button"
                onClick={() => scrollChips('right')}
                style={{
                  backgroundColor: '#f0f0f0',
                  border: '1px solid #ccc',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  flexShrink: 0
                }}
                title="Görgetés jobbra"
              >
                <FiChevronRight size={20} color="#555" />
              </button>
            </div>
          </div>

          {/* INDÍTÁS GOMB */}
          <button
            type="button"
            onClick={handleStartWorkout}
            style={submitButtonStyle}
          >
            🎯 Edzés Indítása
          </button>
        </div>
      </div>

      {/* EGYEDI PONTÉR TÉK HOZZÁADÁSA MODAL */}
      {showAddValueModal && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '350px', textAlign: 'center', padding: '20px' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#b30000' }}>Egyedi pontérték felvétele</h4>
            <p style={{ fontSize: '0.85rem', color: '#666', marginBottom: '15px' }}>
              Írj be egy új pontértéket (pl. 12, 14 vagy X2):
            </p>

            <input
              type="text"
              value={customValueInput}
              onChange={(e) => setCustomValueInput(e.target.value)}
              placeholder="Pl. 14"
              style={{ ...inputStyle, textAlign: 'center', fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '20px' }}
              autoFocus
            />

            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                type="button"
                onClick={() => setShowAddValueModal(false)}
                style={cancelButtonStyle}
              >
                Mégse
              </button>
              <button
                type="button"
                onClick={handleAddCustomValue}
                style={saveButtonStyle}
              >
                Hozzáadás
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// --- STÍLUSOK ---
const pageStyle = { backgroundColor: '#f4f6f8', minHeight: '100vh', boxSizing: 'border-box' };
const headerStyle = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', paddingBottom: '12px', borderBottom: '1px solid #e0e0e0', maxWidth: '550px', margin: '0 auto 20px auto' };
const backButtonStyle = { background: 'none', border: 'none', color: '#333', cursor: 'pointer', display: 'flex', alignItems: 'center', padding: '6px' };
const cardStyle = { backgroundColor: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', border: '1px solid #eee', display: 'flex', flexDirection: 'column', gap: '18px' };
const inputGroupStyle = { display: 'flex', flexDirection: 'column', gap: '6px' };
const labelStyle = { fontSize: '0.85rem', fontWeight: 'bold', color: '#444' };
const inputStyle = { width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '0.95rem', boxSizing: 'border-box', outline: 'none' };
const selectStyle = { width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '0.95rem', backgroundColor: '#fff', cursor: 'pointer', boxSizing: 'border-box' };

const chipContainerStyle = { display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '6px' };
const chipStyle = { padding: '8px 14px', borderRadius: '20px', border: '1px solid #ddd', fontSize: '0.85rem', fontWeight: 'bold', cursor: 'pointer', transition: 'all 0.15s ease' };
const addChipStyle = { padding: '8px 14px', borderRadius: '20px', border: '1px dashed #b30000', backgroundColor: '#fff5f5', color: '#b30000', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' };

const submitButtonStyle = { width: '100%', padding: '12px', backgroundColor: '#b30000', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer', marginTop: '10px', boxShadow: '0 4px 10px rgba(179,0,0,0.25)' };

const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(3px)', zIndex: 10005, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '15px' };
const modalContentStyle = { backgroundColor: 'white', borderRadius: '16px', boxShadow: '0 10px 30px rgba(0,0,0,0.25)', width: '100%' };
const cancelButtonStyle = { flex: 1, padding: '10px', border: 'none', backgroundColor: '#eee', color: '#555', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' };
const saveButtonStyle = { flex: 1, padding: '10px', border: 'none', backgroundColor: '#b30000', color: 'white', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' };

export default CreateWorkout;
